import React, { useState, useEffect, useCallback, useContext } from "react";
import { useFocusEffect } from '@react-navigation/native';
import {
  View,
  StyleSheet,
  KeyboardAvoidingView,
  Platform,
  Keyboard,
  FlatList,
  Dimensions,
  Alert,
} from "react-native";

import colors from "../config/colors";
import Text from "../components/Text";
import dateNow from "../utility/dateNow";
//import useAuth from "../auth/useAuth";
import routes from "../navigation/routes";
import connectionConfig from "../config/settings";
import configurationPost from "../config/configurationPost";
import PickerActionsScreen from "./PickerActionsScreen";
import CardSeed from "../components/CardSeed";
import * as Linking from 'expo-linking';
import dateActions from "../utility/dateActions";
import { AntDesign  } from "@expo/vector-icons";
import ActivityIndicator from "../components/ActivityIndicator";
import CardComponent from "../components/CardComponent";
import AuthContext from "../auth/context";
import { ListItemSeparator } from "../components/lists";
import CardListTypeActions from "../components/CardListTypeActions";
import Icon from "../components/Icon";
import textStyles from "../config/textStyles";

const webUrl = connectionConfig.imageUrl + '/seedImages/'
var seedVideoUri = connectionConfig.imageUrl + '/Documents/videoSeeds/'   // 15 sep 2021 Esto lo paso al CardOriginComponent 
var infoDocumetUri =  connectionConfig.imageUrl +'/Documents/'

var arrayMexActions = []
var pointer = 0
var blockSize = 30
var pageNumber = 0
var arrayActions = []
var date = dateNow()
let newSeedId = 0
var pickSeedId = 0
var fromShowActions = ''
var screenForselectSourceOfTransitionSeed = ''
var seedId = 0
var origin = 0
var experimentDate = ' '
var windowWidth = Dimensions.get('window').width
//---------- Agregado el martes 14 sep 2021 ---------
// Este campo es para que al rerenderizar para los likes desde el showActions nos deje se actualice el seedId
// para las busquedas tanto de contenido como de acciones. 
var transitionSeed = 0  
//------------------------------------------------------

//----------- Miércoles 15 de septiembre del 2021 --------------------------
// Variable para re-renderizar comments de seeds desde action de ShowActions
var rerenderShowActionsXComment = ''
//--------------------------------------------------------------------------


//--------- Pruebas V 30/7/21 ---------------
var arrayContents = []
//-------------------------------------------

var filtroListing = []

function ListingDetailsSeedScreen({ route, navigation, item }) {
  //debugger
  //const [newSeedId, setNewSeedId] = useState(0);
  const [newPath, setNewPath] = useState(0);
  const [showActions, setShowActions] = useState("Show Actions");
  const { user } = useContext(AuthContext)
  //const [statusFollowed, setStatusFollowed] = useState(0)  // martes 14 sep 2021 mude este Hook a CardOriginComponent junto con toda la rutina de Seguidores de la Semilla  
  //const [existFollowed, setExistFollowed] = useState(false) // martes 14 sep 2021 mude este Hook a CardOriginComponent junto con toda la rutina de Seguidores de la Semilla  
  //const [ followers, setFollowers ] =  useState(0)  // martes 14 sep 2021 mude este Hook a CardOriginComponent junto con toda la rutina de Seguidores de la Semilla  
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [listing, setListing] = useState([]);
  const [mexActionsList, setMexActionsList] = useState([]);
  const [listAcciones, setListAcciones] = useState(false)
  const [ menuItems, setMenuItems ] =  useState([]) // para meter la lista del tipo de acciones y desplegaarla en el FlatList de type para su edición.

  var foundUserChecker = route.params.foundUserChecker
  var userId = JSON.parse(user).userId;



//------- Hooks para traer el contenido de cada Seed  ----------------
  const [content, setContent] = useState([]);
//--------------------------------------------------------------------

// variables necesarias para los videos:  
//----------------------------------------
const video =React.useRef(null);
const [status, setStatus] = useState({}); 
//----------------------------------------

// Variable para extrer el seedId del like desde rutina onPressLike
//--------------------------------------------------------------------------
var indexLike = 0
var numLikes = 0
var likeSeedId = 0
//--------------------------------------------------------------------------

console.log('type -> ', route.params.item)

var changeListing = true  // Esta variable hay que eliminarla en todo el código 10 agosto 2021


  const HEIGHT = 315.2727355957031
  //(Dimensions.get('window').height) * .5;
  const sizeItemLayout = ( item, index) => (
    {length: HEIGHT, offset: HEIGHT * index, index}
  );
// Esta variable windowHeight sirve para hacer más corto el view del listing y que así
// no le estorbe la barra del show actions al componente de hasta abajo.
  const windowHeight = Dimensions.get('window').height; 
  var windowHeightMinus = windowHeight - 35

  useFocusEffect(
    useCallback(() => {
        setLoading(true)
        selectSourceOfTransitionSeed()  // lunes 20 sep 2021
        setLoading(false)
    }, [route.params.item, route.params.screen])
  );

  screenForselectSourceOfTransitionSeed = route.params.screen

  const selectSourceOfTransitionSeed = async () => {
    //if( transitionSeed === 0 ) 
    if(screenForselectSourceOfTransitionSeed === 'ListingsSeedsScreen')
    {
      //console.log("transitionSeed antes de select source ", transitionSeed, screenForselectSourceOfTransitionSeed)
      //console.log("screenForselectSourceOfTransitionSeed primer if ", screenForselectSourceOfTransitionSeed)
      //var seedJson = route.params.item.seedId
      //debugger
      //transitionSeed = route.params.item.seedId    
     // var idf = JSON.parse(seedJson) 
      transitionSeed =  route.params.seedId
      seedId = route.params.seedId
      origin = route.params.origin
      console.log("transitionSeed, seedId, origin ", transitionSeed, " ", seedId, " ", origin )
      //seedDate = route.params.item.createDateSeed
    } else { 
      console.log("entre al else ", screenForselectSourceOfTransitionSeed)
      //if( screenForselectSourceOfTransitionSeed === 'AccionSeleccionada'){
      if( screenForselectSourceOfTransitionSeed === 'ActionScreen'){
      //transitionSeed = pickSeedId
      transitionSeed = route.params.seedId
      console.log("transitionSeed, seedId, origin ", transitionSeed, " ", seedId, " ", origin )
      //seedDate = route.params.createDateSeed
      }
    }
    //console.log("transitionSeed despues de select source ", transitionSeed)

    callInitialFunctions()
 }
  
 const callInitialFunctions = async () => {
  arrayMexActions = []
  setMexActionsList([]) 
  setMenuItems([])
  getContentActions()
  reRenderActionsForCommentFromShowActions()
  uauActionsList() 
  getListOfTypeActions()
 }
//-----------------------------------------------------------------
//   Función para traer las Acciones agregadas a una acción
//-----------------------------------------------------------------
const uauActionsList = async () => {
  //debugger
 var filterSeedId = transitionSeed 
  pointer = pageNumber * blockSize  
  setLoading(true)
  var post_values = {
      //userId : userId
     origin:  filterSeedId,   //route.params.seedId,
     type:    10,
     pointer: pointer,
     blockSize : blockSize
  }
  //establece parámetros de configurción del post
  configurationPost.body = JSON.stringify(post_values)
  //solicita el servicio para adquirir los pubicaciones del servidor
  //await fetch(connectionConfig.apiUrl+'/selectActionsFromAction/', configurationPost) // Servicio que se usaba antes de requerir datos del usuario
  await fetch(connectionConfig.apiUrl+'/SelectActionsPlusUsers/', configurationPost)
    .then(response => response.json())
    .then(response => {
      if(response.data.length === 0) {
        if(pageNumber > 0){
          setLoading(false)
        }else{
          setLoading(false)
        }
    }else{
      pageNumber ++  
        if (arrayMexActions.length > 0) {
          arrayMexActions = [ ...arrayMexActions, ...response.data]
        }else{
          arrayMexActions = response.data
            //setShowActions("Hide Actions")
        }
        if(fromShowActions === "vengo de Mostrar Acciones"){
          changeListing = false
          setContent(arrayContents)
        } else {
          setContent(arrayContents)
        }
        setMexActionsList(arrayMexActions)
        setLoading(false)
      }
    })
    .catch(err =>{
         console.log('uauActionsList with SelectActionsPlusUsers failed :( review internet service)', err )
    })  
}
  //-----------------------------------------------------------------------
// Función para traer el tipo de acciones a agregar a la semilla.
// La acción se mostrará en el FlatList en vez de modal para que jale 
// en android tambien.
//-----------------------------------------------------------------------
const getListOfTypeActions = async () => {
  //debugger
   await fetch(connectionConfig.apiUrl+'/getSeedsType/', configurationPost)
     .then(response => response.json())
     .then(response => {
      var result = response.data 
      var skipSeedType = result.filter(result => result.typeNum > 0)
      setMenuItems(skipSeedType)
      //console.log("skipSeed ", skipSeedType)
     } )
     .catch(err =>{
          console.log('getListOfTypeActions /getSeedsType/ failed :( review internet service)', err )
     })  
}

  //imageUrl={webUrl + item.userId + '_' + item.seedPhoto}
//---------------------------------------------
// Función para ir al screen de añadir info
//---------------------------------------------
const onPressInfo = async () => {
   //seedId = listing.seedId,

   navigation.navigate(routes.SEED_INFO, {listing})
}
//---------------------------------------------
// Función para ir al screen de añadir idea
//---------------------------------------------
const onPressIdea = async () => {
    navigation.navigate(routes.SEED_IDEA, {listing})
 }

//---------------------------------------------
// Función para traer el seedId
//---------------------------------------------
const generateActionId = async () => {
  //debugger
  //setProgress(0.3);
  //resetForm()
  var post_values = {
      userId           : JSON.parse(user).userId,
      createDateSeed   : date,
      type             : 1,
      origin           : route.params.seedId
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl+'/insertAction/', configurationPost)
    .then(response => response.json())
    .then(response => {

     
      newSeedId=(response.data.insertId)
      console.log(newSeedId)

     //setNewPath(response.data.insertId)
    
     //pathSelect()
     //console.log(newPath)
     //console.log(response.data.insertId)

      //setProgress(0.7);
      //setUploadVisible(true)
      // if (type = 0) {
      //     pathSeed()

      // }
    })
    .catch(err =>{
      console.log('update fixo failed :( review internet service /insertAction/', err )
    })

};

//--------------------------------------------------
//  Select si se hace path para semilla 
//  u otra acción.
//--------------------------------------------------
const pathSelect = async () => {
console.log("Type es "+ listing.type + "Path es: " + listing.path)
  if(listing.type===0){
  pathSeed()
} else {
  pathAction()
}

  // try {
  //   const result = await ImagePicker.launchImageLibraryAsync({
  //     mediaTypes: ImagePicker.MediaTypeOptions.All,
  //     allowsEditing: true,
  //     aspect: [4, 3],
  //     quality: 0,
  //   })
  //   if(!result.cancelled)
  //   setImageUri(result.uri)
  // } catch (error) {
  //    console.log("error al leer imagen", error) 
  // }
}



//---------------------------------------------
// Función para generar Path de una semilla
//---------------------------------------------
const pathSeed = async () => {
 // debugger
  console.log("ya entre a pathseed")
  //console.log(pathSeed)

  var pathSeed = listing.seedId +"/"+ newSeedId
  setNewPath(pathSeed)
  console.log(pathSeed)
  console.log("ya voy a mandar el pathseed")


  //console.log(newSeedId)

  var post_values = {
      path             : pathSeed,
      seedId           : newSeedId
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl+'/updatePathSeed/', configurationPost)
    .then(response => response.json())
    .then(response => {
      setNewPath(pathSeed)
      //setProgress(0.7);
      //setUploadVisible(true)
      if (type != 0) {
          //pathSeed()
        //console.log(newPath)
      }
    })
    .catch(err =>{
      console.log('update fixo failed :( review internet service /updatePathSeed/', err )
    })

};

//-------------------------------------------------------
// Función para generar path de cualquier otra acción.
//-------------------------------------------------------
const pathAction = async () => {
  //debugger
  console.log("ya entre a pathAction")
  //console.log(pathSeed)

  var pathSeed = listing.path +"/"+ newSeedId
  setNewPath(pathSeed)
  console.log(pathSeed)
  console.log("ya voy a mandar el pathAction")

  var post_values = {
      path             : pathSeed,
      seedId           : newSeedId
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl+'/updatePathSeed/', configurationPost)
    .then(response => response.json())
    .then(response => {
      setNewPath(pathSeed)
      //setProgress(0.7);
      //setUploadVisible(true)
      if (listing.type != 0) {
          //pathSeed()
        //console.log(newPath)
      }
    })
    .catch(err =>{
      console.log('update fixo failed :( review internet service /updatePathSeed/', err )
    })

};

//---------------------------------------------------------------------
//  Para mostrar las Acciones de una semilla en caso de haberlas 
//---------------------------------------------------------------------
const toggleShowActions1 = async () => {
  if(showActions === "Mostrar Acciones" && (mexActionsList.length === 0)){
    alert("Aún no hay acciones que mostrar.Contribuye a esta causa aportando tu creatividad¡¡");
    setShowActions("Mostrar Acciones")
   } else if(showActions === "Ocultar Acciones"){
    setShowActions("Mostrar Acciones") 
   } else {
    setShowActions("Ocultar Acciones") 
   }
}


 const videoNumber = ("WWzEK7NLi74");
  

//-----------------------------------------------------------
// Función para traer las Acciones agregadas a una acción
//-----------------------------------------------------------
const getActionsList = async () => {
       // debugger
       var filterSeedId = transitionSeed //transitionSeed   //filtroListing.seedId   // (changeListing ? listing.seedId : listing[0].seedId)
        pointer = pageNumber * blockSize  
        setLoading(true)
        var post_values = {
            //userId : userId
           origin:  filterSeedId,   //route.params.seedId,
           pointer: pointer,
           blockSize : blockSize
        }
        //establece parámetros de configurción del post
        configurationPost.body = JSON.stringify(post_values)
        //solicita el servicio para adquirir los pubicaciones del servidor
        await fetch(connectionConfig.apiUrl+'/selectActionsFromAction/', configurationPost)
          .then(response => response.json())
          .then(response => {
            if(response.data.length === 0) {
              if(pageNumber > 0){
                setLoading(false)
              }else{
                //setSeedsSucces(false)
                setLoading(false)
            }
          }else{
            pageNumber ++  
              if (arrayActions.length > 0) {
                arrayActions = [ ...arrayActions, ...response.data]
              }else{
                  arrayActions = response.data
              }
              if(fromShowActions === "vengo de show actions"){
                changeListing = false
                setContent(arrayContents)
               // changeListing = true

              } else {
                setContent(arrayContents)
              }
              setItems(arrayActions)
              setLoading(false)
              //setSeedsSucces(true)
            }
          })
          .catch(err =>{
               console.log('getActionsFromAction failed :( review internet service)', err )
          })  
    }

//---------------------------------------------
// OnPress Toggle Show Actions
//---------------------------------------------
const onPressShowActions = async () => {
  if(showActions === "Show Actions"){
    pageNumber = 0
    arrayActions = []
    console.log("Mostrando acciones carnavalito")
    getActionsList();
    setShowActions("Hide Actions")
  } else {
    pageNumber = 0
    setItems([])
    console.log("Hide acciones carnavalito")
    setShowActions("Show Actions")
  }
}


//-------------------------------------------------
//    Martes 14 de septiembre 2021
//Función para re-renderizar getActionList desde 
// CardSeed para actualizar total de likes de una 
// acción en el ShowActions.
//-------------------------------------------------
const reRenderActionsForLike = async () => {
    pageNumber = 0
    arrayActions = []
    console.log("ReRenderizando acciones para actualizar likes")
    getActionsList(); 
    setShowActions("Hide Actions")
}

//-------------------------------------------------
//     Miércoles 15 de septiembre 2021
// Función para re-renderizar getActionList desde 
// CardSeed para actualizar total de likes de una 
// acción en el ShowActions.
//-------------------------------------------------
const reRenderActionsForCommentFromShowActions = async () => {
  if(rerenderShowActionsXComment === 'reRenderPlis'){
    reRenderActionsForLike()
    rerenderShowActionsXComment = ''
    setShowActions("Hide Actions")
  }
}

//--------------------------------------------------------------------------------------------
// Función para traer los datos de el seedId escogido en el FlatList de Actions de la Semilla
//--------------------------------------------------------------------------------------------
const getDataFromSeedActions = async () => {
  //debugger
  // 10 agosto, 2021 reseteo el setContent para evitar me muestre contenido de la semilla de donde viene.
  setContent([])
  setItems([])
  setShowActions("Show Actions")
  //------------

  //changeListing = false

  setLoading(true)
   var post_values = {
     seedId: pickSeedId
    }
   configurationPost.body = JSON.stringify(post_values)
   await fetch(connectionConfig.apiUrl+'/selectActionFromFlatlist/', configurationPost)
   .then(response => response.json())
   .then(response => {
    //  var arr = []
    // setListing(arr)
    //changeListing = false
    filtroListing = response
    console.log("filtroListing regresando de getDataFromSeedActions ", filtroListing)
    // 10 agosto, 2021 hice esta función getContentActionPickSeedId igual a getContent 
    // para que muestre el contenido de la acción seleccionada desde Show Actions
    //getContentActionPickSeedId()
    //--------------------------
    setListing(response.data)
    setLoading(false)
    setItems([])
    setShowActions("Show Actions")
    //changeListing = true
    fromShowActions = "vengo de show actions"
   })
   .catch(err =>{
   console.log(':( review internet service /selectActionFromFlatlist/', err )
   })
}


// martes 14 de septiembre del 2021 ... Corte de aqui la rutina de Follow de la semilla.

//---------------------------------------------
//Obtiene el documento de la info
//---------------------------------------------
const retriveDoc = async () => {
  //debugger
      if(filtroListing.documentSeed.includes('.pdf')){
           //Linking.openURL(infoDocumetUri +'pdfSeeds/'+ listing.documentSeed) 
           Linking.openURL(infoDocumetUri +'pdfSeeds/'+ filtroListing.documentSeed) 

      } 
      if(filtroListing.documentSeed.includes('.png')){
          //Linking.openURL(infoDocumetUri + 'imageSeedsPng/' + listing.documentSeed)
          Linking.openURL(infoDocumetUri + 'imageSeedsPng/' + filtroListing.documentSeed)

      }
      if(filtroListing.documentSeed.includes('.jpg')){
          //Linking.openURL(infoDocumetUri + 'imageSeedsB/' + listing.documentSeed)
          Linking.openURL(infoDocumetUri + 'imageSeedsB/' + filtroListing.documentSeed)

      }
      if(filtroListing.documentSeed.includes('.xls')){
          //Linking.openURL(infoDocumetUri + 'ExcellSeeds/' + listing.documentSeed)
          Linking.openURL(infoDocumetUri + 'ExcellSeeds/' + filtroListing.documentSeed)
      }
      if(filtroListing.documentSeed.includes('.xlsx')){
          //Linking.openURL(infoDocumetUri + 'ExcellSeeds/' + listing.documentSeed)
          Linking.openURL(infoDocumetUri + 'ExcellSeeds/' + filtroListing.documentSeed)
      }
}


//-----------------------------------------------------------------------
// Función para traer las Acciones de contenido a cada acción
//-----------------------------------------------------------------------
const getContentActions = async () => {
  console.log("entre a ListngDetailsSeedScreen a funcion getContentActions ", transitionSeed)
  //debugger
  pageNumber = 0
  arrayContents = []
  //var filterType = 33
   pointer = pageNumber * blockSize  
   setLoading(true)
   var post_values = {
       //userId : userId
      origin: transitionSeed, //route.params.item.seedId, contentSeedId,
      seedId: transitionSeed, //route.params.item.seedId, esto lo incluí el dom 5 sep 2021 para ingresar el origin al FlatList
   //   type: filterType,
      pointer: pointer,
      blockSize : blockSize,
   }
   //establece parámetros de configurción del post
   configurationPost.body = JSON.stringify(post_values)
   //solicita el servicio para adquirir los pubicaciones del servidor
   await fetch(connectionConfig.apiUrl+'/selectContentActionsWeb/', configurationPost)
     .then(response => response.json())
     .then(response => {
       if(response.data.length === 0) {
         if(pageNumber > 0){
           setLoading(false)
         }else{
           //setSeedsSucces(false)
           setLoading(false)
       }
     }else{
       pageNumber ++  
         if (arrayContents.length > 0) {
          arrayContents = [ ...arrayContents, ...response.data]
         }else{
          arrayContents = response.data
         }
         if(fromShowActions === "vengo de show actions"){
          changeListing = false
          setContent(arrayContents)
          //changeListing = true
          setLoading(false)
        } else {
          setContent(arrayContents)
        }
          setLoading(false)
          //setSeedsSucces(true)
     }
     getDateFormat()
     })
     .catch(err =>{
          console.log('getContentFromAction failed :( review internet service)', err )
     })  
}

//------------------------------------------------------------------------------------------
// Función para generar la fecha de creación más leíble para el usuario
//------------------------------------------------------------------------------------------
const getDateFormat = async () => {

  var seedDate = arrayContents[0].createDateSeed  //route.params.item.createDateSeed // 3-Nov-21 Debo arreglar que no dependa del .item porque sino no jala desde el show actions

  experimentDate = dateActions(seedDate)  // Variable que transforma la fecha de creación 
                                              // para enviarla por parámetro en los Flatlists 
                                              // CardComponent y CardSeed. 
  
}

//------------------------------------------------------------------------------------------
// Función para traer las Acciones de contenido a una acción seleccionada desde ShowActions
//------------------------------------------------------------------------------------------
const getContentActionPickSeedId = async () => {
  //debugger
  pageNumber = 0
  seedId = pickSeedId
  console.log("Cambiando el seedId por pickSeedId para que no cambie la semilla en los likes ", seedId)
    arrayContents=[]
    setContent([])
    setItems([])
    setShowActions("Show Actions")
  var filterType = 4
   pointer = pageNumber * blockSize  
   setLoading(true)
   var post_values = {
       //userId : userId
      origin: pickSeedId,  //route.params.item.seedId, //contentSeedId,
      seedId: pickSeedId,
      type: filterType,    
      pointer: pointer,
      blockSize : blockSize,
   }
   //establece parámetros de configurción del post
   configurationPost.body = JSON.stringify(post_values)
   //solicita el servicio para adquirir los pubicaciones del servidor
   await fetch(connectionConfig.apiUrl+'/selectContentActions/', configurationPost)
     .then(response => response.json())
     .then(response => {
       if(response.data.length === 0) {
         if(pageNumber > 0){
           setLoading(false)
         }else{
           //setSeedsSucces(false)
           setLoading(false)
       }
     }else{
       pageNumber ++  
         if (arrayContents.length > 0) {
          arrayContents = [ ...arrayContents, ...response.data]
         }else{
          arrayContents = response.data
          route.params = response.data
         }
         if(fromShowActions === "vengo de show actions"){
          changeListing = false
          setContent(arrayContents)
          //changeListing = true
          setLoading(false)
        } else {
          setContent(arrayContents)
        }
          setLoading(false)
          //setSeedsSucces(true)
     }
          // setContent(response.data)


     })
     .catch(err =>{
          console.log('getContentFromAction failed :( review internet service)', err )
     })  
}

const posibleNewAction = async () => {
  setShowActions("Mostrar Acciones")
  setListAcciones(false)
  //debugger
  type = typeActionSelect 
  var actionsNum = 0
  origin = route.params.item.seedId
  if(typeActionSelect === 1){seedId = 11} // Para que renderice en ActionEditScreen le debo de dar un número de semilla con el tipo de acción a dar de alta, sino no renderiza.
  var screen ='CreateAction'   // Le puse ChooseTypeContent en screen para 
                                    // que al entrar al useEffect de ActionEditScreen jale la nueva
                                    // acción.
  
  console.log("saliendo de ListingDetailsSeedScreen y yendo a AddAction con..... seedId: ", seedId,' origin: ', origin, ' type ', type)
 
  navigation.navigate(routes.ACTION_EDIT_SCREEN, { type, seedId, origin, foundUserChecker, changeListing, screen, actionsNum } ) 
}

//******************************************************************************************
//              Pruebas para hacer el Insert Up or Down de componentes
//******************************************************************************************
// var contentSeedIdPlusCreateDate = content.map((content) => { 
//   var contentResumen = {};
//   contentResumen[content.seedId] = ( content.seedId )
//   return contentResumen;
//   });
// console.log("contentSeedIdPlusCreateDate ", contentSeedIdPlusCreateDate)

var insertContent = "down"
const indexSeed = content.findIndex(seedId => seedId === seedId);
if(insertContent === "down"){
  //console.log("indexSeed ", indexSeed)
}

//                              AQUI TERMINAN PRUEBAS
//******************************************************************************************

 return (
    <>
    <View style={{flex: 1, backgroundColor: colors.fondoGeneral}}>
    <ActivityIndicator visible={loading}/>
         <FlatList
          getItemLayout={sizeItemLayout}
          data={content}
          keyExtractor={(item) => item.seedId.toString()}
          initialScrollIndex={items.index}
          // onEndReachedThreshold={0.5}
          // onEndReached={() => getContentActions()}  

         // initialScrollIndex={route.params.index}
          
          renderItem={({ item, index}) => (
            // <View onLayout= {object => 
            //         itemHeights[index] = object.nativeEvent.layout.height}>
            
              <CardComponent
                userName={item.userName}
                type={item.type}  
                title={item.seedName}
                seedDescription={item.seedDescription}
                seedId={item.seedId}
                seedName={item.seedName} 
                seedPhoto={item.seedPhoto}
                origin={item.origin}
                userPhoto={item.userPhoto}
                subTitle={item.totalSeedLikes}
                videoNumber={item.youtubeId}
                documentSeed={item.documentSeed} 
                userId={item.userId}
                foundUserChecker={foundUserChecker}
                navigation={navigation}
                seedDate={item.createDateSeed}
                content={content}
                seedOrder={item.seedOrder}
                getContentActions={() => {getContentActions()}} // Este funciona el like en content pero si viene de showactions al dar like se va a la semilla anterior.
                //getContentActions={() => {getContentActionPickSeedId()}} // Este mantiene la semilla actual pero si esta de contenido te pone ese contenido como el principal.
                onPressNumLikes={() => {
                  indexLike = index
                  var pick = content[index].seedId
                  navigation.navigate(routes.LISTING_LIKE_USER_PUBLICATION, {pick}  );
                  console.log("presNumLique", indexLike)
                  }                  
                }
                imageUrl={
                  item.seedPhoto.includes('.mp4') ?
                  seedVideoUri + item.seedPhoto :
                  item.seedPhoto.includes('.mov') ?
                  seedVideoUri + item.seedPhoto :
                  webUrl + item.seedPhoto}
                
                onPressLike={ () => {
                  indexLike = index
                  // if(JSON.parse(user).alias === 'notUser' ){
                  if(Platform.OS === 'web' ){
                          // alert('notUser')
                    navigation.navigate('ViewImage')
                  }else{
                    onPressValidationLikeUser()
                  }
                 }
                }
                commentsNum={item.totalSeedComments}
                actionsNum={item.totalActions}
                onPressComment={() => {
                  indexLike = index
                  var pick = items.seedId   //items[indexLike].seedId
                      // if(JSON.parse(user).alias === 'notUser' ){
                  if(Platform.OS === 'web' ){
                          // alert('notUser')
                      navigation.navigate('ViewImage')
                   }else{
                      navigation.navigate(routes.COMMENTS_SEEDS, {item, pick})
                   }
                  }
                }
                thumbnailUrl={webUrl + item.userId + '_' + item.seedPhoto}
                getDataFromSeedActions={() => {
                  pickSeedId =  items[index].seedId
                  getDataFromSeedActions()
                  //navigation.navigate(routes.SEED_DETAILS, { pickSeedId }) //item
                  }
                }
                urlOG={item.urlOG}
              />
            //  </View>
          )}
        />

{ 
showActions === "Ocultar Acciones" ?

          <View style={styles.flatActions} >
          <View style={styles.menuFlatActions}>
          <Text style={styles.textFlatActions}> Todas </Text>
          </View>  
          <FlatList
          getItemLayout={sizeItemLayout}
          data={mexActionsList}
          keyExtractor={(item) => item.seedId.toString()}
          initialScrollIndex={items.index}
          onEndReachedThreshold={0.5}
          onEndReached={() => uauActionsList()}
          ItemSeparatorComponent={ListItemSeparator}
         // initialScrollIndex={route.params.index}
          
          renderItem={({ item, index}) => (
            // <View onLayout= {object => 
            //         itemHeights[index] = object.nativeEvent.layout.height}>
              <CardSeed
                title={item.seedName}
                seedDescription={item.seedDescription}
                subTitle={item.totalSeedLikes} // 
                seedId={item.seedId}
                origin={item.origin}
                type={item.type}  
                userId={userId}
                foundUserChecker={foundUserChecker}
                seedDate={item.createDateSeed}
                totalActions={item.totalActions}
                userIdOfAction={item.userId}
                userName={item.userName}
                userPhoto={item.userPhoto}
                reRenderActionsForLike={() => {reRenderActionsForLike()}}
                onPressNumLikes={() => {
                  indexLike = index
                  seedId = items[index].seedId
                  navigation.navigate(routes.LISTING_LIKE_USER_PUBLICATION, {seedId}  );
                  console.log("presNumLique", indexLike)
                  }                  
                }
                imageUrl={
                  item.seedPhoto.includes('.mp4') ?
                  seedVideoUri + item.seedPhoto :
                  item.seedPhoto.includes('.mov') ?
                  seedVideoUri + item.seedPhoto :
                  webUrl + item.seedPhoto}
                
                onPress={() => {
                  pickSeedId = mexActionsList[index].seedId
                  //console.log("Llegue al onPress de ListingDetailsSeedScreen para traer la acción seleccionada ", pickSeedId)
                  transitionSeed = pickSeedId
                  screenForselectSourceOfTransitionSeed = 'AccionSeleccionada'
                  console.log("Llegue al onPress de ListingDetailsSeedScreen para ir a la acción y el transitionSeed es: ", transitionSeed, "AccionSeleccionada ", screenForselectSourceOfTransitionSeed  )
                  arrayContents=[]
                  getContentActionPickSeedId()
                  //getDataFromSeedActions()
                  //navigation.navigate(routes.SEED_DETAILS, { pickSeedId }) //item
                  }
                }

                getDataFromSeedActions={() => {
                  pickSeedId =  items[index].seedId
                  getDataFromSeedActions()
                  //navigation.navigate(routes.SEED_DETAILS, { pickSeedId }) //item
                  }
                }
                commentsNum={item.totalSeedComments}
                onPressComment={() => {
                  rerenderShowActionsXComment = 'reRenderPlis'
                  indexLike = index
                  var seedId = items.seedId   //items[indexLike].seedId
                      // if(JSON.parse(user).alias === 'notUser' ){
                     if(Platform.OS === 'web' ){
                          // alert('notUser')
                           navigation.navigate('ViewImage')
                      }else{
                       navigation.navigate(routes.COMMENTS_SEEDS, {item, seedId })
                      }
                  }
                }
                thumbnailUrl={webUrl + item.userId + '_' + item.seedPhoto}
              />
          )}
        /> 
        </View>
        :
        null
}

{
    listAcciones === true ?
    <View style={route.params.item.type === 1 ? styles.ViewflatlistTypeAction1:
                  route.params.item.type === 2 ? styles.ViewflatlistTypeAction2:
                  route.params.item.type === 3 ? styles.ViewflatlistTypeAction3:
                  route.params.item.type === 4 ? styles.ViewflatlistTypeAction4:
                  route.params.item.type === 5 ? styles.ViewflatlistTypeAction5:
                  route.params.item.type === 6 ? styles.ViewflatlistTypeAction6:
                  route.params.item.type === 7 ? styles.ViewflatlistTypeAction7:
                  route.params.item.type === 8 ? styles.ViewflatlistTypeAction8:
                  styles.ViewflatlistTypeAction9
    }>
    <FlatList
      data={menuItems}
      keyExtractor={(menuItem) => menuItem.typeActionsId.toString()}
      ItemSeparatorComponent={ListItemSeparator}
      renderItem={({ item, index }) => (
        <CardListTypeActions
          title ={item.typeActionsDesc}
          IconComponent={
            <Icon
              iconFamily={item.iconFamily}
              name={item.icon}
              size ={35}      //{item.size}
              backgroundColor={item.backgroundColor}
            />
          }
          onPress={() =>{ 
            typeActionSelect = menuItems[index].typeNum
            console.log("typeActionSelect==> ", typeActionSelect)
            //setUploadVisible(false)
            //generateActionId()
            posibleNewAction()
          }}
        />
      )}
    />
    <Text style={{alignSelf: "center", fontSize: colors.textLarge, color: "white", marginBottom: "2%"}}
    onPress={() =>{ 
      setListAcciones(false)
    }}>Cancel</Text>
    </View>
    :
    null
} 
          {/* <FlatList
          getItemLayout={sizeItemLayout}
          data={items}
          keyExtractor={(item) => item.seedId.toString()}
          initialScrollIndex={items.index}
          onEndReachedThreshold={0.5}
          onEndReached={() => getActionsList()}

         // initialScrollIndex={route.params.index}
          
          renderItem={({ item, index}) => (
            // <View onLayout= {object => 
            //         itemHeights[index] = object.nativeEvent.layout.height}>
              <CardSeed
                title={item.seedName}
                subTitle={item.totalSeedLikes} // 
                seedId={item.seedId}
                origin={item.origin}
                userId={userId}
                foundUserChecker={foundUserChecker}
                seedDate={experimentDate}
                reRenderActionsForLike={() => {reRenderActionsForLike()}}
                onPressNumLikes={() => {
                  indexLike = index
                  seedId = items[index].seedId
                  navigation.navigate(routes.LISTING_LIKE_USER_PUBLICATION, {seedId}  );
                  console.log("presNumLique", indexLike)
                  }                  
                }
                imageUrl={
                  item.seedPhoto.includes('.mp4') ?
                  seedVideoUri + item.seedPhoto :
                  item.seedPhoto.includes('.mov') ?
                  seedVideoUri + item.seedPhoto :
                  webUrl + item.seedPhoto}
                
                onPress={() => {
                  //changeListing = false
                  pickSeedId = items[index].seedId
                  //console.log("Llegue al onPress de ListingDetailsSeedScreen para traer la acción seleccionada ", pickSeedId)
                  transitionSeed = pickSeedId
                  screenForselectSourceOfTransitionSeed = 'AccionSeleccionada'
                  console.log("Llegue al onPress de ListingDetailsSeedScreen para ir a la acción y el transitionSeed es: ", transitionSeed, "AccionSeleccionada ", screenForselectSourceOfTransitionSeed  )
                  arrayContents=[]
                  getContentActionPickSeedId()
                  //getDataFromSeedActions()
                  //navigation.navigate(routes.SEED_DETAILS, { pickSeedId }) //item
                  }
                }

                getDataFromSeedActions={() => {
                  pickSeedId =  items[index].seedId
                  getDataFromSeedActions()
                  //navigation.navigate(routes.SEED_DETAILS, { pickSeedId }) //item
                  }
                }
                commentsNum={item.totalSeedComments}
                actionsNum={item.totalActions}
                onPressComment={() => {
                  rerenderShowActionsXComment = 'reRenderPlis'
                  indexLike = index
                  var seedId = items.seedId   //items[indexLike].seedId
                  navigation.navigate(routes.COMMENTS_SEEDS, {item, seedId })
                  }
                }
                thumbnailUrl={webUrl + item.userId + '_' + item.seedPhoto}
              />
          )}
        />  */}

             {
               route.params.item.type === -1 ? 
               null 
               :
               <>
          <View style={styles.seedTitle}>
         {/* <View  
          style={ route.params.item.type === 0 ? styles.seedTitle :
            route.params.item.type === 1 ? styles.seedTitle1 :
            route.params.item.type === 2 ? styles.seedTitle2 :
            route.params.item.type === 3 ? styles.seedTitle3 :
            route.params.item.type === 4 ? styles.seedTitle4 :
            route.params.item.type === 5 ? styles.seedTitle5 :
            route.params.item.type === 6 ? styles.seedTitle6 :
            route.params.item.type === 7 ? styles.seedTitle7 :
            route.params.item.type === 8 ? styles.seedTitle8 :
            route.params.item.type === 9 ? styles.seedTitle9 :
          styles.seedTitle9
           }> */}         
            {/* <View style={styles.pickerStyle1}>
                <AntDesign style={styles.heartButton}
                  name="heart"
                  size={22} //35
                  color= {colors.chakra2ama}
                  onPress={() => {
                    listAcciones === false ?
                    setListAcciones(true)
                      :
                    setListAcciones(false)
                  }}
                />
            </View> */}
                <AntDesign style={styles.pickerStyle2}
                name="pluscircle"
                size={31} //38
                color= {colors.primary}
                onPress={() => {
                 // if(JSON.parse(user).alias === 'notUser' ){
                  if(Platform.OS === 'web' ){
                    // alert('notUser')
                     navigation.navigate('ViewImage')
                }else{
                  listAcciones === false ?
                  setListAcciones(true)
                    :
                  setListAcciones(false)
                }
                }}
              />
               <View style={styles.pickerStyle}>
                        <Text style={styles.showActions}
                              onPress={toggleShowActions1}
                        > {showActions}     {mexActionsList.length}
                        </Text>
                </View>
               {/* <PickerActionsScreen style={styles.pickerStyle}
                                         navigation={ navigation } 
                                         seedId = { transitionSeed }
                                        />
                    <Text onPress={onPressShowActions}
                          style={styles.showActions}
                    > 
                      {showActions} 
                    </Text> */}
                     </View>
               </>
             }
         
            </View>
    </>
  );
}
    
const styles = StyleSheet.create({
  flatActions:{
    height: "92%",
    //flex: 1
  },
  menuFlatActions:{
    height: "7%",
    backgroundColor: colors.verdeCaribe
  },
  textFlatActions: {
    marginTop: "3%",
    marginLeft: "3%",
    fontSize:textStyles.textLarge,
    color: colors.textGeneral
  },
  pickerStyle: {
    width:'45%',
    alignItems: "center",
    flexDirection: "row",
    alignSelf: "center",
    borderRadius: 20,
    backgroundColor: colors.primary,
    padding: 2,
    marginLeft: '18%',
    //marginBottom: "4%"
  },
  pickerStyle2: {    // Style del botón para dar de alta Acciones.
    marginTop: windowWidth > 600 ? "3%" :"5%",
    marginLeft: "8%", 
    marginBottom:"1%",
   // size:30,
    //marginRight: "7%",
   alignItems: "center",
   justifyContent: "center",
   // zIndex: 1,
   width:29,
   height:29,
    backgroundColor:colors.chakra2ama,
    borderRadius:35
  },
  heartButton: {
    //marginTop: "-1%", 
    marginLeft: 10
  },
  pickerStyle1: {    // Style del botón para dar de alta Acciones.
    //marginTop: "1%",
    marginLeft:  "4.5%", //(windowWidth * 0.09),    //"6%",
    //marginRight: "7%",
    alignItems: "center",
    justifyContent: "center",
    //zIndex: 1,
  },  
  seedTitle:{
    flexDirection: "row",
    alignSelf: "flex-end",
    height: '10%',
    width: "100%", 
    backgroundColor: colors.fondoImagenes,
    zIndex: 1,
   // marginBottom:25
  },
  seedTitle1:{
    flexDirection: "row",
    alignSelf: "flex-end",
    height: "10%",
    width: "100%", 
    backgroundColor: colors.chakra1nar,
    zIndex: 1
  },
  seedTitle2:{
    flexDirection: "row",
    alignSelf: "flex-end",
    height: "10%",
    width: "100%", 
    backgroundColor: colors.chakra2ama,
    zIndex: 1
  },
  seedTitle3:{
    flexDirection: "row",
    alignSelf: "flex-end",
    height: "10%",
    width: "100%", 
    //alignItems: 'center',
    backgroundColor: colors.chakra3ver,
    zIndex: 1
  },
  seedTitle4:{
    flexDirection: "row",
    alignSelf: "flex-end",
    height: "10%",
    width: "100%", 
    //alignItems: 'center',
    backgroundColor: colors.chakra4azu,
    zIndex: 1
  },
  seedTitle5:{
    flexDirection: "row",
    alignSelf: "flex-end",
    height: "10%",
    width: "100%", 
   //alignItems: 'center',
    backgroundColor: colors.chakra5vlt,
    zIndex: 1
  },
  seedTitle6:{
    flexDirection: "row",
    alignSelf: "flex-end",
    height: "10%",
    width: "100%", 
    //alignItems: 'center',
    backgroundColor: colors.chakra6rsa,
    zIndex: 1
  },
  seedTitle7:{
    flexDirection: "row",
    alignSelf: "flex-end",
    height: "10%",
    width: "100%", 
    //alignItems: 'center',
    backgroundColor: colors.chakra7ryo,
    zIndex: 1
  },
  seedTitle8:{
    flexDirection: "row",
    alignSelf: "flex-end",
    height: "10%",
    width: "100%", 
    //alignItems: 'center',
    backgroundColor: colors.chakra8tur,
    zIndex: 1
  },
  seedTitle9:{
    flexDirection: "row",
    alignSelf: "flex-end",
    height: "10%",
    width: "100%", 
    //alignItems: 'center',
    backgroundColor: colors.chakra9aur,
    zIndex: 1
  },
showActions: {
  marginLeft: "7%",
  fontSize: colors.textMedium,    //22,
  color: colors.white,
}

  
});

export default ListingDetailsSeedScreen;
